import { useEffect } from 'react';
import { Layout6Root } from './Layout6Root';
import './styles.css';
import './services.css';
import { LayoutHeader as Header } from '@/layouts';
import { useTheme } from '@/contexts/ThemeContext';
import { LayoutFooter as Footer } from '@/layouts';
import { Button } from '@/components/ui/button';
import { useAppData } from '@/contexts/AppDataContext';
import { openWhatsApp } from '@/lib/whatsapp';
import { useStore } from '@/contexts/StoreContext';
import { MessageCircle } from 'lucide-react';
import { ServiceCard } from './ServiceCard';

const Services = () => {
  const { config } = useAppData();
  const { selectedStore } = useStore();
  const store = selectedStore || config.stores[0];
  const services = store.services || [];
  const { colors } = useTheme();
  const buttonColor = colors.button;
  const primaryColor = colors.primary;

  useEffect(() => {
    document.title = `Serviços - ${config.name}`;
  }, [config.name]);

  return (
    <Layout6Root withHeader className="wl6-services-page">
      <Header config={config} />

      <section className="wl6-section">
        <div className="wl6-container">
          <div className="wl6-section-header">
            <div>
              <p className="wl6-eyebrow">Serviços</p>
              <h1 className="wl6-h2 mt-1">Tudo para fechar negócio</h1>
              <p className="wl6-lead mt-1 max-w-lg text-sm">
                Financiamento, avaliação e muito mais em um só lugar.
              </p>
            </div>
          </div>

          {services.length === 0 ? (
            <div className="wl6-services-empty">
              <MessageCircle className="h-8 w-8 mx-auto mb-3 text-[var(--wl6-muted)] opacity-50" />
              <p className="font-semibold text-[var(--wl6-text)]">Nenhum serviço disponível no momento</p>
              <p className="text-sm text-[var(--wl6-muted)] mt-1">Entre em contato para saber como podemos ajudar.</p>
            </div>
          ) : (
            <div className="wl6-services-grid">
              {services.map((service: { service: string; image?: string }, index: number) => (
                <ServiceCard
                  key={`${service.service}-${index}`}
                  service={service}
                  config={config}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="wl6-section wl6-services-cta-section pt-0">
        <div className="wl6-container">
          <div className="wl6-cta" style={{ backgroundColor: primaryColor }}>
            <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-[var(--wl6-on-primary)]">
                  Precisa de ajuda com algum serviço?
                </h2>
                <p className="text-[var(--wl6-on-primary)] opacity-85 mt-2 max-w-md">
                  Fale com nossa equipe agora e receba atendimento personalizado.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 shrink-0">
                <Button
                  size="lg"
                  className="rounded-lg bg-white font-semibold h-12 px-6 hover:bg-white/90"
                  style={{ color: buttonColor }}
                  onClick={() => openWhatsApp(store.whatsapp?.ios)}
                >
                  <MessageCircle className="h-5 w-5 mr-2" />
                  WhatsApp
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="rounded-lg font-semibold h-12 px-6 border-white/30 text-white bg-white/10 hover:bg-white/20 hover:text-white"
                  onClick={() => { window.location.href = `tel:${store.phone?.formatted}`; }}
                >
                  Ligar agora
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer config={config} />
    </Layout6Root>
  );
};

export default Services;
